(function ($) {
    function Dashboard() {
        this.sliderConfig = null;
        this._report = null;

        this.dashboard = $('.f-dashboard-wrap');
        this.adminDashboard = $('.enrollment-dashboard');

        this.init();
        this.addListeners();
    }

    Dashboard.prototype = {
        init: function() {
            let self = this,
                recommendedCoursesElement = self.dashboard.find('.recommended-courses .course-item-wrap'),
                courseStatusElement = self.dashboard.find('.course-status-wrap .course-item-wrap');

            self.sliderConfig = {
                infinite: true,
                slidesToShow: 2,
                slidesToScroll: 1,
                speed: 500,
                autoplay: true,
                autoplaySpeed: 7000,
                prevArrow: '<button type="button" class="slick-prev"><i class="la la-angle-left"></i></button>',
                nextArrow: '<button type="button" class="slick-next"><i class="la la-angle-right"></i></button>',
                responsive: [
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 1,
                            dots: true,
                            arrows: false
                        }
                    }
                ]
            }

            recommendedCoursesElement.slick(self.sliderConfig);
            courseStatusElement.slick(self.sliderConfig);

            var coupon_code = self.adminDashboard.find('.filter [name=coupon_code]').val();
            if (coupon_code) {
                $('#tmec').remove();
                $('#tme').remove();
                self.adminDashboard.find('.export').remove();
            }

            // Admin dashboard
            self._report = {
                year: self.adminDashboard.find('.filter [name=year]').val(),
                by: self.adminDashboard.find('.filter [name=by]').val(),
                coupon_type: self.adminDashboard.find('.filter [name=coupon_type-tme]').val(),
                report_type: coupon_code ? 'faculty' : 'tme',
                coupon_code: coupon_code ?? '',
                sort: self.adminDashboard.find('.filter [name=sort]').val(),
                conference_year: '',
                conference_month: '',
                conference_code: '',
                conference_location_code: '',
                conference_name: ''
            }

            if (self.adminDashboard.length)
                self.getReport();
        },

        addListeners: function() {
            let self = this;

            // Change Report Type
            self.adminDashboard.find('.nav-tabs .nav-link').click(function (event) {
                event.preventDefault();
                let type = $(this).data('type');

                self.adminDashboard.find('.nav-tabs .nav-link').removeClass('active');

                if (type === 'conference') {
                    self.adminDashboard.find('.filter').hide();
                    self.adminDashboard.find('.live-registration-filter').hide();
                    self.adminDashboard.find('.conference-registration-filter').show();
                } else if (type !== 'live-registration') {
                    self.adminDashboard.find('.live-registration-filter').hide();
                    self.adminDashboard.find('.conference-registration-filter').hide();
                    self.adminDashboard.find('.filter').show();
                    self.adminDashboard.find('.filter .coupon-type').hide();
                    self.adminDashboard.find('.filter #' + type).show();
                    self._report.coupon_type = self.adminDashboard.find('.filter #' + type + ' select').val();
                } else {
                    self.adminDashboard.find('.filter').hide();
                    self.adminDashboard.find('.conference-registration-filter').hide();
                    self.adminDashboard.find('.live-registration-filter').show();
                }

                $(this).addClass('active');
                self._report.report_type = type;

                self.getReport();
            });

            // Change Year
            self.adminDashboard.find('.filter [name=year]').change(function () {
                self._report.year = $(this).val();
                self.getReport();
            });

            // Change By
            self.adminDashboard.find('.filter [name=by]').change(function () {
                self._report.by = $(this).val();
                self.getReport();
            });

            // Change Coupon Type
            self.adminDashboard.find('.filter [name=coupon_type-tme]').change(function () {
                self._report.coupon_type = $(this).val();
                self.getReport();
            });

            self.adminDashboard.find('.filter [name=coupon_type-tmec]').change(function () {
                self._report.coupon_type = $(this).val();
                self.getReport();
            });

            self.adminDashboard.find('.filter [name=sort]').change(function () {
                self._report.sort = $(this).val();
                self.getReport();
            });

            self.adminDashboard.find('.filter [name=course_type]').change(function () {
                self._report.course_type = $(this).val();
                self.getReport();
            });

            self.adminDashboard
                .find('.live-registration-filter [name=year]')
                .on('change', function () {
                    self._report.live_registration_year = $(this).val();
                    self.showLiveCourseByYear();
                    self.getReport();
                });

            self.adminDashboard
                .find('.live-registration-filter [name=month]')
                .on('change', function () {
                    self._report.live_registration_month = $(this).val();
                    self.showLiveCourseByYear();
                    self.getReport();
                });

            self.adminDashboard
                .find('.live-registration-filter [name=program_code]')
                .on('change', function () {
                self._report.program_code = $(this).val();
                self.getReport();
            });

            self.adminDashboard
                .find('.live-registration-filter [name=location_code]')
                .on('change', function () {
                    self._report.location_code = $(this).val();
                    self.getReport();
                });

            self.adminDashboard
                .find('.live-registration-filter [name=course_name]')
                .on('change', function () {
                    self._report.course_name = $(this).val();
                    self.getReport();
                });

            // For conference registration filter
            for (const key of ['conference_year', 'conference_month', 'conference_code', 'conference_location_code', 'conference_name']) {
                self.adminDashboard
                    .find('.conference-registration-filter [name="' + key + '"]')
                    .on('change', function () {
                        self._report[key] = $(this).val();

                        if (key === 'conference_year' || key === 'conference_month')
                            self.showConferenceByYear();

                        self.getReport();
                    });
            }

            // Export
            self.adminDashboard.find('.export .btn-export').click(function (event) {
                event.preventDefault();

                let url = new URL(pageData.home_url + '/dashboard/export-total-monthly-report'),
                    urlParams = url.searchParams;

                $.each(self._report, function (index, value) {
                    urlParams.append(index, value);
                });

                urlParams.append('export', 1);
                window.open(url.toString(), '_blank');
            });
        },

        getReport: function() {
            let self = this;

            $.ajax({
                url: pageData.home_url + '/dashboard/enrollment',
                type: "GET",
                data: self._report
            })
                .done(function (response) {
                    self.adminDashboard.find('.result').empty().html(response.content);
                })
                .fail(function () {

                });
        },

        showConferenceByYear: function (year) {
            let self = this,
                selectedMonth;

            if (!self._report.conference_year && self._report.conference_month) {
                alert('Please select a year');
                return;
            }

            if (self._report.conference_month) {
                selectedMonth = self._report.conference_year;

                if (self._report.conference_month > 9)
                    selectedMonth += '-' + self._report.conference_month;
                else
                    selectedMonth += '-0' + self._report.conference_month;
            }

            $('#conference_name option').each(function () {
                let optionYear = $(this).attr('data-year'),
                    optionMonth = $(this).attr('data-month');

                if (!$(this).attr('value'))
                    return;

                if (!self._report.conference_year) {
                    $(this).show();
                    return;
                }

                if (selectedMonth) {
                    if (optionMonth.indexOf(selectedMonth) > -1)
                        $(this).show();
                    else
                        $(this).hide();

                    return;
                }

                if (optionYear.indexOf(self._report.conference_year) > -1)
                    $(this).show();
                else
                    $(this).hide();
            });
        },

        showLiveCourseByYear: function () {
            let self = this,
                selectedMonth;

            if (!self._report.live_registration_year && self._report.live_registration_month) {
                alert('Please select a year.');
                return;
            }

            if (self._report.live_registration_month) {
                selectedMonth = self._report.live_registration_year;

                if (self._report.live_registration_month > 9)
                    selectedMonth += '-' + self._report.live_registration_month;
                else
                    selectedMonth += '-0' + self._report.live_registration_month;
            }

            self.adminDashboard
                .find('.live-registration-filter [name=course_name] option')
                .each(function () {
                    let optionYear = $(this).attr('data-year'),
                        optionMonth = $(this).attr('data-month');

                    if (!$(this).attr('value'))
                        return;

                    if (!self._report.live_registration_year) {
                        $(this).show();
                        return;
                    }

                    if (selectedMonth) {
                        if (optionMonth.indexOf(selectedMonth) > -1)
                            $(this).show();
                        else
                            $(this).hide();

                        return;
                    }

                    if (optionYear.indexOf(self._report.live_registration_year) > -1)
                        $(this).show();
                    else
                        $(this).hide();
                });
        }
    }

    $(document).ready(function() {
        new Dashboard();
    });
}) (jQuery)
